import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import Grid from '../Grid';
import Select from '../Select';
import Form from '../Form';
import Popup from './Popup';
import Button from '../Button';
import UsersSearch from './UsersSearch';
import SaveChangesButton from '../SaveChangeButtonPopup';
import s from './Popup.css';
import Messages from './Messages';
import cx from 'classnames';
import { optionsParser } from '../../core/utils';

class EditOwnershipPopupView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      
    };
  }

  getTitle = (intl, messages, usersCount) => {
    if (usersCount > 1) {
      return `${intl.formatMessage({
        ...messages.create_ownership_popup_title,
      })} (${usersCount} ${intl.formatMessage({
        ...messages.edit_popup_users_text,
      })} )`;
    }
    return `${intl.formatMessage({
      ...messages.create_ownership_popup_title,
    })} (${usersCount} ${intl.formatMessage({
      ...messages.edit_popup_user_text,
    })} )`;
  };

  onClick = () => {
    console.log('clicked')
    // this.props.onSubmit();
  };

  render() {
    const { intl, ownershipData, devicetype, serial } = this.props;
    const users = ownershipData.get('users');
    const usersOptions = users.toArray().map(optionsParser);
    const searchQuery = ownershipData.get('searchQuery');
    const usersCount = users.toArray().length;
    const messages = Messages();

    const title = this.getTitle(intl, messages, usersCount);
    const isSuperior = devicetype === 'superior';

    if (usersCount) {
      return (
        <Popup
          className={s.Popup__editdevice}
          onClose={this.props.onClose}
          devicetype={devicetype}
          overrideOnClose
        > 
          {serial}
          <UsersSearch
            searchQuery={searchQuery}
            setSearchQuery={this.props.setSearchQuery}
            usersCount={usersCount}
          />
          <Form onSubmit={this.props.onSubmit}>
            <Grid.Cell>
              <Select
                name="users"
                title={title}
                options={usersOptions}
                large
              />
            </Grid.Cell>
            <div className={s.saveButton}>
              <SaveChangesButton 
                devicetype={devicetype} 
                onClick={this.onClick}
              />
            </div>
          </Form>
        </Popup>
      )
    }
    return (
      <Popup
        className={s.Popup__editdevice}
        onClose={this.props.onClose}
        devicetype={devicetype}
        overrideOnClose
      > 
        <UsersSearch
          searchQuery={searchQuery}
          setSearchQuery={this.props.setSearchQuery}
          usersCount={usersCount}
        />
          <FormattedMessage
            {...messages.no_users_found_title}
          />
      </Popup>
    );
  }
}

EditOwnershipPopupView.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  setSearchQuery: PropTypes.func.isRequired,
  ownershipData: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  intl: intlShape.isRequired,
  serial: PropTypes.string.isRequired,
  devicetype: PropTypes.string,
};

EditOwnershipPopupView.defaultProps = {
  devicetype: '',
};

export default injectIntl(withStyles(s)(EditOwnershipPopupView));



// WEBPACK FOOTER //
// ./src/components/Popup/EditOwnershipPopupView.js